import { call, cancelled, put, takeEvery, takeLatest } from "redux-saga/effects";
import { SNIPPETS } from "./actionTypes";
import { emptyStringToNull } from "../../helpers/null_empty_string_helper";
import { SNIPPETS_URL } from "../../helpers/url_api_helper";
import { duplicateSnippet, getListaSnippet, getSnippet, getSnippetHistory, getSnippetHistoryList, getSnippetPreview, getSnippetProducts, getSnippetSections, postSnippetDownloadList, saveSnippet } from "./actions";
import moment from "moment";
import { stringToBase64 } from "../../helpers/base64_helper";
import { normalizeApiError } from "../../helpers/utils/normalizeApiError";

function* listarSnippets({ payload }) {
    const filterSnippet = payload;
    const controller = new AbortController();
    try {
        emptyStringToNull(filterSnippet);
        const res = yield call(SNIPPETS_URL.getSnippetsLista, filterSnippet, {
            signal: controller.signal,
        });
        yield put(getListaSnippet.success(res));
    } catch (error) {
        yield put(
            getListaSnippet.fail((
                normalizeApiError(
                    error,
                    "Something went wrong retrieving the system's snippets, please try again later"
                )
            )));
    } finally {
        if(yield cancelled()) {
            controller.abort();
        }
    }
};

function* salvarSnippet({ payload }) {
    const { body, method } = payload;
    const { id } = body;
       
    try {
        body.id = id === null ? null : id;
        body.content = body.content.map(block => ({
            ...block,
            content: stringToBase64(block.content)
        }));
        
        
        if (method === "POST") {
            yield call(SNIPPETS_URL.postSnippet, body);
            yield put(saveSnippet.success(true));
        }
        else {
            yield call(SNIPPETS_URL.putSnippet, body);
            yield put(saveSnippet.success(true));
        }
    }
    catch (error){
        yield put(
            saveSnippet.fail(
                normalizeApiError(
                    error,
                    "Something went wrong saving the system snippet, please try again later"
                )
            )
        );
    }
};

function* obterSnippet({ payload }) {
    const { snippetId } = payload;
    try {
        const res = yield call(SNIPPETS_URL.getSnippet, snippetId);

        res.activeStatus = res.active === true ? ["Active Status"] : [];
        res.deletedStatus = res.deleted === true ? ["Active Status"] : [];
        res.createDate = moment(res.createDate).format("DD MMM/YY hh:mm A").toString();
        res.updateDate = res.updateDate !== null ? moment(res.updateDate).format("DD MMM/YY hh:mm A").toString() : "";
        
        yield put(getSnippet.success(res));
    }
    catch (error) {
        yield put(
            getSnippet.fail((
                normalizeApiError(
                    error,
                    "Something went wrong retrieving the system's snippet, please try again later"
                )
            )));
    }
};

function* salvarDuplicateSnippet({ payload }) {
    const { snippetId } = payload;
    try {
        const res =yield call(SNIPPETS_URL.postSnippetDuplicate, snippetId);
        yield put(duplicateSnippet.success(res));
    }
    catch (error) {
        yield put(
            duplicateSnippet.fail(
                normalizeApiError(
                    error,
                    "Something went wrong retrieving the system's snippet, please try again later"
                )
            )
        );
    }
};

function* listarSnippetHistory ({ payload }) {
    const { snippetId, page } = payload;

    try {
        const res = yield call(SNIPPETS_URL.getSnippetHistoryList, snippetId, page);
        yield put(getSnippetHistoryList.success(res));
    } catch (error) {
        yield put(
            getSnippetHistoryList.fail(
                normalizeApiError(
                    error,
                    "Something went wrong retrieving the system's snippet, please try again later"
                )
            )
        )
    }
};

function* obterSnippetHistory ({ payload }) {
    const { snippetId } = payload;

    try {
        const res = yield call(SNIPPETS_URL.getSnippetHistory, snippetId);

        res.activeStatus = res.active === true ? ["Active Status"] : [];
        res.deletedStatus = res.deleted === true ? ["Active Status"] : [];
        res.createDate = moment(res.createDate).format("DD MMM/YY hh:mm A").toString();
        res.updateDate = res.updateDate !== null ? moment(res.updateDate).format("DD MMM/YY hh:mm A").toString() : "";
        
        yield put(getSnippetHistory.success(res));
    } catch (error) {
        yield put(
            getSnippetHistory.fail(
                normalizeApiError(
                    error,
                    "Something went wrong retrieving the system's snippet, please try again later"
                )
            )
        )
    }
};

function* obterSnippetProducts ({ payload }) {
    const { snippetId } = payload;
    try {
        const res = yield call(SNIPPETS_URL.getSnippetProducts, snippetId);
        yield put(getSnippetProducts.success(res));
    } catch (error) {
        yield put(
            getSnippetProducts.fail(
                normalizeApiError(
                    error,
                    "Something went wrong retrieving the system's snippet products, please try again later"
                )
            )
        )
    }
};

function* obterSnippetSections ({ payload }) {
    const { snippetId } = payload;
    try {
        const res = yield call(SNIPPETS_URL.getSnippetSections, snippetId);
        yield put(getSnippetSections.success(res));
    } catch (error) {
        yield put(
            getSnippetSections.fail(
                normalizeApiError(
                    error,
                    "Something went wrong retrieving the system's snippet sections, please try again later"
                )
            )
        )
    }
};

function* obterSnippetPreview ({ payload }) {
    const { snippetId } = payload;
    try {
        const res = yield call(SNIPPETS_URL.getSnippetPreview, snippetId);
        yield put(getSnippetPreview.success(res));
    } catch (error) {
        yield put(
            getSnippetPreview.fail(
                normalizeApiError(
                    error,
                    "Something went wrong retrieving the system's snippet preview, please try again later"
                )
            )
        )
    }
};

function* obterSnippetDownloadList({ payload }) {
    const { objFilter } = payload;
    
    try {
        const res = yield call(SNIPPETS_URL.postSnippetDownloadList, objFilter);
        yield put(postSnippetDownloadList.success(res));
    } catch (error) {
        yield put(
            postSnippetDownloadList.fail(
                normalizeApiError(
                    error,
                    "Something went wrong downloading the snippets, please try again later"
                )
            )
        )
    }
}


function* SnippetsSaga() {
    yield takeLatest(SNIPPETS.GET_LIST_SNIPPET.REQUEST, listarSnippets);
    yield takeEvery(SNIPPETS.SAVE_SNIPPET.REQUEST, salvarSnippet);
    yield takeEvery(SNIPPETS.GET_SNIPPET.REQUEST, obterSnippet);
    yield takeEvery(SNIPPETS.DUPLICATE_SNIPPET.REQUEST, salvarDuplicateSnippet);
    yield takeEvery(SNIPPETS.GET_SNIPPET_HISTORY_LIST.REQUEST, listarSnippetHistory);
    yield takeEvery(SNIPPETS.GET_SNIPPET_HISTORY.REQUEST, obterSnippetHistory);
    yield takeEvery(SNIPPETS.GET_SNIPPET_PRODUCTS.REQUEST, obterSnippetProducts); 
    yield takeEvery(SNIPPETS.GET_SNIPPET_SECTIONS.REQUEST, obterSnippetSections);
    yield takeEvery(SNIPPETS.GET_SNIPPET_PREVIEW.REQUEST, obterSnippetPreview);
    yield takeEvery(SNIPPETS.POST_SNIPPET_DOWNLOAD_LIST.REQUEST, obterSnippetDownloadList);
}

export default SnippetsSaga;